<template>
    <nav class="breadcrumb-line mt-2" aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li v-for="(crumb, index) in crumbs" :key="index"
                :class="['breadcrumb-item', { active: index === crumbs.length - 1 }]" aria-current="page">
                <router-link v-if="index !== crumbs.length - 1" :to="crumb.link">{{ crumb.text }}</router-link>
                <span v-else>{{ crumb.text }}</span>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    props: {
        crumbs: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.breadcrumb {
    background: none;
    padding: 0 10px;
    margin: 0;
    font-size: 16px;
}

.breadcrumb-item {
    font-weight: 500;
}

.breadcrumb-item span {
    font-weight: 500;
    color: var(--theme-font-primary);
}

.breadcrumb-item+.breadcrumb-item::before {
    content: ">";
    font-weight: 600;
    font-size: 18px;
    color: var(--theme-font-primary);
}

@media (max-width: 767px) {
    .breadcrumb-line {
        display: contents;
    }

    .breadcrumb {
        justify-content: start;
        font-size: 14px;
        padding: 0 10px;
    }

    .breadcrumb-item+.breadcrumb-item::before {
        content: ">";
        font-weight: 600;
        font-size: 16px;
        color: var(--theme-font-primary);

    }

}
</style>